const BaseAnalytics = require("../base/BaseAnalytics");

const {
    PLCC_FORM_START,
    PLCC_FORM_SUBMIT,
    PAGE_LOAD
} = require("../models/Plcc");

class PLCCAnalytics extends BaseAnalytics {
    constructor() {
        const DOM_PAGE_DATA = ["js-a-page-customer", "js-a-page-cart", "js-a-page-store", "js-a-page-data", "js-a-page-instance"];
        super("PLCCAnalytics", DOM_PAGE_DATA, PAGE_LOAD);
    }

    /**
     * Initializing the class with collect(), engages all analytics listeners
     *
     * @memberof PLCCAnalytics
     */
    collect() {
        this.pageInterceptedEvents();
    }
    /**
     * Initializes the PLCCAnalytics class by invoking `pdCollect()`.
     * 
     * Note: We avoid calling `collect()` directly here because `plccinit.js` is imported globally.
     * Instead, we trigger analytics listeners only when the specific page (defined in the ISML) is loaded.
     *
     * This ensures that analytics events are engaged at the appropriate lifecycle stage of the page.
     *
     * @memberof PLCCAnalytics
     */
    pdCollect() {
        this.prepareDOMElements();
        this.getPageData();
        this.baseEvents();
        this.baseInterceptedEvents();
        this.baseDelayedEvents();
        this.preparePageDesignerData();
    }

    /**
     * Initialize page intercepted events
     */
    pageInterceptedEvents() {
        this.addNativeEventListeners("plccFormStartEvent", window, event => this.plccFormStart(event));
        this.addNativeEventListeners("plccFormSubmitEvent", window, event => this.plccFormSubmit(event));
    }

    /**
     * PLCC Form start event
     * @param {Object} _event
     */
    plccFormStart(_event) {
        this.prepareSingleEvent(PLCC_FORM_START, {});
    }


    /**
     * PLCC Form submit event
     * @param {Object} event
     */
    plccFormSubmit(event) {
        const eventData = event.detail.customer;
        let domData = {
            plccApplicationStatus: eventData.plccApplicationStatus
        };

        this.prepareSingleEvent(PLCC_FORM_SUBMIT, domData);
    }
}

module.exports = PLCCAnalytics;
